export default __webpack_public_path__ + "static/media/kapadokya-turkiye.776dc6ea.jpg";